import { Schema } from 'effect';
import { SiteId } from './common.js';
/** DTO schemas for the /site group. See http/payment.ts for conventions. */
export const IdParams = Schema.Struct({ id: Schema.String });
export const SiteParams = Schema.Struct({ site: SiteId });
/** The shared `BackendResult` shape. */
export const BackendResultResponse = Schema.Struct({
    success: Schema.Boolean,
    message: Schema.String
});
export const AccountResponse = Schema.Struct({
    canOrder: Schema.Boolean,
    tier: Schema.String
});
export const SubscriptionUrlQuery = Schema.Struct({
    finalUrl: Schema.optional(Schema.String),
    log: Schema.optional(Schema.String)
});
export const UrlResponse = Schema.Struct({ url: Schema.String });
export const MessageResponse = Schema.Struct({ message: Schema.String });
//# sourceMappingURL=site.js.map